import actionTypes from "../actionTypes";

export const FETCH_USER = actionTypes("FETCH_USER");

export const CONFIRM_USER = actionTypes("CONFIRM_USER");

export const SET_APP_MODE = actionTypes("SET_APP_MODE");
